import React from 'react';
import { exportToCSV, exportToPDF } from '../../utils/exportUtils';
import { logExportEvent } from '../../utils/logExport';
import { toast } from 'react-toastify';
import * as htmlToImage from 'html-to-image';
import './ExportButton.css';

const ExportButton = ({ data, filenameBase, label, endpoint, containerId }) => {
  const handleExport = async (format) => {
    const timestamp = new Date().toISOString();
    const filename = `${filenameBase}-${timestamp.slice(0, 10)}.${format}`;

    try {
      if (format === 'csv') exportToCSV(data, filename);
      if (format === 'pdf') exportToPDF(data, filename);

      await logExportEvent({
        type: format,
        source: filenameBase,
        timestamp,
      });


    } catch (err) {
      console.error(err);
      toast.error(`❌ Failed to export ${format.toUpperCase()}`);
    }
  };

  const exportChartImage = async (containerId, filename, format = 'png') => {
    const node = document.getElementById(containerId);
    if (!node) return toast.error('❌ Chart container not found');

    try {
      const dataUrl =
        format === 'svg'
          ? await htmlToImage.toSvg(node)
          : await htmlToImage.toPng(node);

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${filename}.${format}`;
      link.click();


    } catch (err) {
      console.error('Image export failed:', err);
      toast.error('❌ Failed to export chart image');
    }
  };

  const downloadFromEndpoint = async () => {
    if (!endpoint) return;

    try {
      const response = await fetch(endpoint);
      if (!response.ok) throw new Error('Export failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      const filename =
        response.headers.get('Content-Disposition')?.split('filename=')[1] ||
        'export.json';
      a.download = filename.replace(/"/g, '');
      a.click();
      window.URL.revokeObjectURL(url);


    } catch (err) {
      console.error('❌ Export error:', err);
      toast.error('❌ Failed to export from server');
    }
  };

  return (
    <div className="chart-actions">
      <button className="export-btn" onClick={() => handleExport('csv')}>
        📄 Export CSV
      </button>
      <button className="export-btn" onClick={() => handleExport('pdf')}>
        🧾 Export PDF
      </button>

      {containerId && (
        <>
          <button
            className="export-btn"
            onClick={() => exportChartImage(containerId, filenameBase, 'png')}
          >
            🖼️ Export PNG
          </button>
          <button
            className="export-btn"
            onClick={() => exportChartImage(containerId, filenameBase, 'svg')}
          >
            📐 Export SVG
          </button>
        </>
      )}

      {label && endpoint && (
        <button className="export-btn" onClick={downloadFromEndpoint}>
          {label}
        </button>
      )}
    </div>
  );
};

export default ExportButton;
